.host {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--color-solitude-white);
  border: 0.4rem solid var(--color-solitude-white);
  border-radius: 2.1rem;
}

.host:hover .imageActions {
  display: flex;
}

.imageActions {
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  display: none;
  align-items: center;
}

.actionButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  background-color: var(--color-aqua-haze);
  border-radius: 1.2rem;
  cursor: pointer;
}

.iconHolder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.8rem;
  height: 4.8rem;
  font-weight: bold;
  font-size: 1.2rem;
  background-color: rgba(var(--color-gumbo-rgb), 0.4);
  border-radius: 1rem;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.filename {
  display: flex;
  align-items: center;
  margin-top: 1.6rem;
  color: var(--color-semantic-text-neutral30);
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 1.7rem;
}

.filesize {
  margin-top: 2rem;
  color: var(--color-semantic-text-neutral20);
  font-size: 1.2rem;
}

.removeBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.2rem;
  height: 1.2rem;
  margin-left: 0.4rem;
  background: var(--color-semantic-surface-neutral30);
  border-radius: 50%;
  cursor: pointer;
}

.removeBtn svg {
  width: 1rem;
  height: 1rem;
}

.downloadPdfBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  background-color: var(--color-solitude-white);
  border-radius: 1.2rem;
  cursor: pointer;
}

.successBadge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.6rem;
  height: 5.6rem;
  background-color: var(--color-state--success);
  border-radius: 2.4rem;
}

.successBadge svg {
  color: var(--color-white);
}

.successLabel {
  margin-top: 1.4rem;
  color: var(--color-semantic-text-neutral30);
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 1.7rem;
}
